import React from "react"
import "./AboutCordovaSimple.css"

const AboutCordovaSimple = () => {
  return (
    <section className='about-cordova-simple-section'>
      <div className='container'>
        <div className='about-simple-content'>
          <h2 className='about-simple-title'>About Cordova</h2>
          <p className='about-simple-description'>
            Cordova Franchising is built on over two decades of unparalleled
            expertise in IT staffing and talent solutions. We empower
            entrepreneurs to own and scale their own IT staffing companies using
            our proven, 8-figure per year model. Join a recession-proof industry
            with our complete business system and ongoing support.
          </p>
        </div>
      </div>
    </section>
  )
}

export default AboutCordovaSimple
